module.exports = __webpack_public_path__ + "static/apple-touch-icon-120x120-83024323dfbb219aec442aa7aa0c38a1.png";